var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3086 20.2885C13.9148 23.708 7.55929 23.3984 3.52067 19.3598C-0.853202 14.9859 -0.853202 7.89446 3.52067 3.52059C7.89454 -0.853283 14.986 -0.853282 19.3599 3.52059C23.3985 7.55921 23.708 13.9148 20.2885 18.3086L27.2795 25.2995C27.8262 25.8462 27.8262 26.7326 27.2795 27.2794C26.7327 27.8261 25.8463 27.8261 25.2996 27.2794L18.3086 20.2885ZM17.38 17.3799C20.6604 14.0995 20.6604 8.78089 17.38 5.50049C14.0996 2.22008 8.78097 2.22008 5.50057 5.50049C2.22016 8.78089 2.22016 14.0995 5.50057 17.3799C8.78097 20.6603 14.0996 20.6603 17.38 17.3799Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.416bde01.svg";
export { ForwardRef as ReactComponent };